import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Autocomplete, Button, Dialog, DialogContent, TextField, } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useExportAccountTransactionsMutation, } from "generated/generated-models";
import { DateField } from "@mui/x-date-pickers";
import { Box } from "@mui/system";
import { CError } from "app/common/CError";
import { toDateOnly } from "core/util/dateExtensions";
const dateRangeOptions = [
    "Last 7 Days",
    "Last 14 Days",
    "Last 30 Days",
    "Last Month",
    "Last Quarter",
    "Custom Range",
];
export function ExportDateRangeModal({ accountId, open, onClose, exportFormat, }) {
    const [dateRange, setDateRange] = useState("");
    const showDateFields = dateRange == "Custom Range";
    const [createExportAccountTransactions, { loading, error }] = useExportAccountTransactionsMutation();
    let fromDate = new Date();
    let toDate = new Date();
    const getFromDate = () => {
        let sevenDaysAgo, fourteenDaysAgo, thirtyDaysAgo, lastMonthStart, lastQuarterStart;
        switch (dateRange) {
            case "Last 7 Days":
                sevenDaysAgo = new Date();
                sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
                fromDate = sevenDaysAgo;
                break;
            case "Last 14 Days":
                fourteenDaysAgo = new Date();
                fourteenDaysAgo.setDate(fourteenDaysAgo.getDate() - 14);
                fromDate = fourteenDaysAgo;
                break;
            case "Last 30 Days":
                thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                fromDate = thirtyDaysAgo;
                break;
            case "Last Month":
                lastMonthStart = new Date();
                lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
                fromDate = lastMonthStart;
                break;
            case "Last Quarter":
                lastQuarterStart = new Date();
                lastQuarterStart.setMonth(lastQuarterStart.getMonth() - 3);
                fromDate = lastQuarterStart;
                break;
        }
    };
    const handleExport = async () => {
        getFromDate();
        const result = await createExportAccountTransactions({
            variables: {
                input: {
                    AccountId: accountId,
                    FromDate: toDateOnly(fromDate),
                    ToDate: toDateOnly(toDate),
                    Format: exportFormat,
                },
            },
        });
        if (result.errors ||
            !result.data?.exportAccountTransactions?.ExportString) {
            return;
        }
        else {
            const exportString = atob(result.data.exportAccountTransactions.ExportString);
            const blob = new Blob([exportString], {
                type: "application/octet-stream",
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Transactions." + exportFormat.toLowerCase();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            onClose();
        }
    };
    return (_jsx(Dialog, { fullScreen: false, open: open, onClose: onClose, fullWidth: true, PaperProps: {
            sx: {
                overflow: "unset",
            },
        }, children: _jsxs(DialogContent, { sx: { m: 4, overflow: "unset" }, children: [_jsx(Autocomplete, { id: "date-range-select", disablePortal: true, onChange: (_event, newValue) => {
                        toDate = new Date();
                        setDateRange(newValue);
                    }, options: dateRangeOptions, renderInput: (params) => (_jsx(TextField, { ...params, label: "Date Range" })) }), showDateFields && (_jsxs(Box, { sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 1.5,
                    }, children: [_jsx(DateField, { label: "Starting On", onChange: (date) => (fromDate = date), sx: { zIndex: 0, marginRight: 1 } }), _jsx(DateField, { label: "Ending On", onChange: (date) => (toDate = date), sx: { zIndex: 0, marginLeft: 1 } })] })), error && (_jsx(Box, { style: {
                        marginTop: 10,
                    }, children: _jsx(CError, { error: error?.message }) })), _jsxs("div", { className: "button-row", children: [_jsx(Button, { className: "btn-cancel", id: "cancel", sx: { p: 1.5, mt: 1 }, variant: "contained", onClick: onClose, children: "Cancel" }), _jsx(LoadingButton, { className: "btn-sendMessage", type: "submit", id: "submit", loading: loading, onClick: handleExport, sx: { p: 1.5, mt: 1 }, variant: "contained", disabled: !dateRange, children: "Export" })] })] }) }));
}
